import { useAuth } from "../../../context";
import { useQuery } from "react-query";
import { PhysicalRiskApi } from "../../../api";

export function usePhysicalRiskMenziesReport(params, config) {
  const { callApi } = useAuth();
  return useQuery(["physicalRiskMenzies", params.year, params.quarter],
    () => callApi(PhysicalRiskApi.getPhysicalRiskMenziesReport, params), config);
}
